import {SubAPI} from "./SubAPI";

export class PDFTable extends SubAPI {

    tableClassName = "pdf-table-rendered";
    pageClassName = "pdf-table-page";
    defaultStyle = {visibility: "hidden", height: 10} as any;

    encodeContent(param: {
        title?: string;
        header: string[];
        content: string[][]
    }) {
        return JSON.stringify(param);
    }
}